import {IconDefinition} from "@ant-design/icons-angular";
import {DeleteOutline, DownloadOutline, FilePdfFill} from "@ant-design/icons-angular/icons";

export const NZ_CF_ICONS: IconDefinition[] = [
  DeleteOutline,
  DownloadOutline,
  FilePdfFill
];
